import React from 'react';
import ABICManagement from './ABICManagement';

const ABICManagementPage = () => {
  return <ABICManagement />;
};

export default ABICManagementPage;
